// modal.js

// 汎用お知らせモーダル
(function () {
  // 配列を順にモーダル表示する関数
  function showNewsModal(newsArray) {
    if (!Array.isArray(newsArray) || newsArray.length === 0) return;
    let currentIndex = 0;
    function showModal(index) {
      const news = newsArray[index];
      if (!news) return;
      const overlay = document.createElement("div");
      overlay.className = "modal-overlay";
      overlay.innerHTML = `
        <div class="modal">
          <button class="modal-close" aria-label="閉じる">×</button>
          <h3 class="modal-title">${news.title ?? ""}</h3>
          <div class="modal-body">
            ${news.body ?? ""}
          </div>
        </div>
      `;
      document.body.appendChild(overlay);
      overlay.querySelector(".modal-close").onclick = function () {
        overlay.remove();
        currentIndex++;
        if (currentIndex < newsArray.length) {
          showModal(currentIndex);
        }
      };
      overlay.onclick = function (e) {
        if (e.target === overlay) {
          overlay.remove();
          currentIndex++;
          if (currentIndex < newsArray.length) {
            showModal(currentIndex);
          }
        }
      };
    }
    showModal(currentIndex);
  }

  // ページ内にid="news-modal-data"のJSONがあれば自動で表示
  document.addEventListener("DOMContentLoaded", function () {
    var el = document.getElementById("news-modal-data");
    if (el) {
      try {
        var arr = JSON.parse(el.textContent || el.innerText || "[]");
        if (Array.isArray(arr) && arr.length > 0) {
          showNewsModal(arr);
        }
      } catch (e) {}
    }
  });

  // グローバルAPIとしても提供
  window.showNewsModal = showNewsModal;
})();
